// extracted by mini-css-extract-plugin
module.exports = {"modal":"popup_modal__1Fc34","modalContent":"popup_modalContent__1TvpK","close":"popup_close__3y9QO"};